module.exports = __webpack_public_path__ + "static/media/icon_menu.5ee5a685.svg";